// Staff chat error answers (contract): `{ error: "<code>" }`.
//   403 not_org_staff       the caller is not active staff of the org: "no access", never retried.
//   503 store_unavailable | directory_unavailable | patient_unavailable: the backend is not ready: a quiet state.
// Only the status and the error code are read; the rest of a body is never shown or logged.
import { ApiError } from '@/shared/api/api-client';

export type StaffChatErrorKind = 'no-access' | 'unavailable' | 'other';

export const NO_ACCESS_TITLE = 'You do not have access to Messages';
export const UNAVAILABLE_TITLE = 'Messages are not available right now';
export const UNAVAILABLE_DESCRIPTION = 'Please try again later.';
export const OPEN_THREAD_FAILED = "Couldn't open the conversation. Try again.";

export function staffChatErrorCode(err: unknown): string | null {
  if (!(err instanceof ApiError)) return null;
  try {
    const parsed: unknown = JSON.parse(err.body);
    const code = parsed && typeof parsed === 'object' ? (parsed as { error?: unknown }).error : undefined;
    return typeof code === 'string' ? code : null;
  } catch {
    return null;
  }
}

export function staffChatErrorKind(err: unknown): StaffChatErrorKind {
  if (!(err instanceof ApiError)) return 'other';
  if (err.status === 403) return 'no-access';
  if (err.status === 503) return 'unavailable';
  return 'other';
}

/** TanStack `retry`: never on an answer from the server that a retry cannot change (4xx, 503); twice on anything else. */
export function staffChatRetry(failureCount: number, err: unknown): boolean {
  if (err instanceof ApiError && ((err.status >= 400 && err.status < 500) || err.status === 503)) return false;
  return failureCount < 2;
}

/** The picker's line for a failed find-or-create: no access (403), not available (503), or try again. */
export function openThreadError(err: unknown): string {
  const kind = staffChatErrorKind(err);
  return kind === 'no-access' ? NO_ACCESS_TITLE : kind === 'unavailable' ? `${UNAVAILABLE_TITLE}.` : OPEN_THREAD_FAILED;
}
